import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const JapanFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15216'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15216)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.0006 11.2C12.3675 11.2 14.2863 9.31965 14.2863 7.00005C14.2863 4.68045 12.3675 2.80005 10.0006 2.80005C7.63362 2.80005 5.71484 4.68045 5.71484 7.00005C5.71484 9.31965 7.63362 11.2 10.0006 11.2Z'
					fill='url(#paint0_linear_2332_15216)'
				/>
			</g>
			<defs>
				<linearGradient
					id='paint0_linear_2332_15216'
					x1='5.71484'
					y1='2.80005'
					x2='5.71484'
					y2='11.2'
					gradientUnits='userSpaceOnUse'>
					<stop stopColor='#D81441' />
					<stop
						offset='1'
						stopColor='#BB0831'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default JapanFlagIcon;
